import { Component, Inject, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Base } from '../../base';
import { MatDialog } from '@angular/material/dialog';
import { ValidationService } from '../../../../utils/util.validation';
import { DetallesBeneficios, DetallesBeneficiosAnexos } from '../../../../models/poblacion/mi-poblacion';
import { NgxSpinnerService } from "ngx-spinner";
import { PoblacionService } from '../../../../services/poblacion/poblacion.service';
import { DialogPoblacionDetalleAnexosComponent } from '../dialog-poblacion-detalle-anexos/dialog-poblacion-detalle-anexos.component';
import { UtilFormat } from '../../../../utils/format';

@Component({
  selector: 'app-dialog-poblacion-detalle',
  templateUrl: './dialog-poblacion-detalle.component.html',
  styleUrls: ['./dialog-poblacion-detalle.component.css']
})
export class DialogPoblacionDetalleComponent extends Base {
[x: string]: any;

  @ViewChild('cellphoneInput') cellphoneInput!: ElementRef;
  @ViewChild('emailInput') emailInput!: ElementRef;
  @Output() generateEvent = new EventEmitter<number>();
  dataDetail!: DetallesBeneficios;
  dataAnexos!: DetallesBeneficiosAnexos;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogPoblacionDetalleComponent>,
    private matDialog: MatDialog,    
    private poblacionService: PoblacionService,
    private spinner: NgxSpinnerService    
  ) {
    super();    
    this.dataDetail = data;
    if(this.dataDetail.Anexos == "SI"){ //si contiene anexos carga servicios y abre dialogo
      this.spinner.show();
      let json = {
        contrato: this.dataDetail.Contrato,
        integrante: this.dataDetail.integrante,
      }
      this.poblacionService.getDetalleAnexosUsuarioMiPoblacion(json).subscribe({
        next: response => {
          this.spinner.hide();
          if (response.data.length != 0) {
            this.dataAnexos = response.data;
          } else {
            console.error("No se pudo obtener la data de los anexos.")
          }
        },
        error: error => {
          this.spinner.hide();          
        }
      });
    }
  }

  openAnexos(){
    if(this.dataAnexos){
      this.matDialog.open(DialogPoblacionDetalleAnexosComponent, {
        disableClose: true,
        data: this.dataAnexos
      });
    }
  }

  formatMoney(valor:string){
    return UtilFormat.formatMoney(valor);
  }
  
  close(){
    this.dialogRef.close();
  }
}
